import { Box, Heading } from '@chakra-ui/layout'
import { useToast } from '@chakra-ui/react'
import { FileOnlyPdfExcelGenerator } from 'components/molecules/FileOnlyPdfExcelGenerator'
import { useInstitutionsContext } from 'contexts/institutions'
import { GlobalFilter } from 'pages/components/GlobalFilter'
import { DocumentTypes } from 'pages/Report/types'
import { useRef, useState } from 'react'
import { getAccessReportFile } from 'services/users'
import { generateFile } from 'utils/blob'
import { ModeTable } from './components/ModeTable'
import { formFilter } from './form'
import { filterSchema } from './schema'
import { AccessFilter } from './types'

export const Accesses = () => {
    const toast = useToast()
    const [loadingFile, setLoadingFile] = useState<boolean>(false)
    const { currentInstitution } = useInstitutionsContext()
    const [filter, setFilter] = useState<AccessFilter>({})
    const refModeTable = useRef<any>(null)
    

    const callAPI = (type: DocumentTypes) => {
        downloadFile(type)
    }

    const setCurrentFilters = (value: any) => {
        setFilter(value)
        refModeTable?.current?.resetPage && refModeTable?.current?.resetPage()
    }
    
    const downloadFile = async (type: DocumentTypes) => {
        try {
            setLoadingFile(true)

            const response = await getAccessReportFile(
                {
                    ...filter,
                    tipo: type
                },
                currentInstitution?.id,
        )

            generateFile(type, response)

            toast({
                title: 'Arquivo gerado com sucesso!',
                description: `O arquivo ${type} foi gerado. Verifique sua pasta de downloads.`,
                status: 'success',
                // ...
            })
        } catch (error) {
            toast({
                title: 'Sentimos muito!',
                description: 'Ocorreu algum erro ao gerar o arquivo.',
                status: 'error',
                // ...
            })
        } finally {
            setLoadingFile(false)
        }
    }

    return (
        <>
            <GlobalFilter
                schema={filterSchema}
                form={formFilter}
                actionFilter={setCurrentFilters}
                loadingFilter={false}
                title="Filtrar Relatório de Acessos"
            />

            <Box display="flex" justifyContent="space-between" margin="24px 0">
                <Heading size="md"> </Heading>
                <FileOnlyPdfExcelGenerator callAPI={callAPI} loading={loadingFile} />
            </Box>

            <ModeTable
                filter={filter}
                ref={refModeTable}
            />
        </>
    )
}